import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DealDispositionsService } from 'src/app/deals/deal-dispositions/deal-dispositions.service';
import { DispositionDistributionProceedInput } from 'src/app/deals/deal-dispositions/graphql/dispositions';
import DispositionDistribution from 'src/app/interfaces/disposition-distribution';
import DispositionDistributionProceed from 'src/app/interfaces/disposition-distribution-proceed';
import { ConfirmationModalComponent } from '../../confirmation-modal/confirmation-modal.component';

export type ProceedList = {
  name: string;
  disposition_distribution_id: string;
  id: string | null;
  type: string;
  proceeds: DispositionDistributionProceed[];
};

@Component({
    selector: 'disposition-distribution-proceed',
    templateUrl: './disposition-distribution-proceed.component.html',
    styleUrls: ['./disposition-distribution-proceed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionDistributionProceedComponent {
  @Input() dispositionDistribution: DispositionDistribution;
  @Input() proceedList: ProceedList;
  @Input() readOnly: boolean = true;
  timeout: any;

  @Output() proceedUpdated = new EventEmitter<boolean>();
  constructor(
    public dispositionsService: DealDispositionsService,
    private dialog: MatDialog
  ) {}
  addProceed() {
    let proceedInput: DispositionDistributionProceedInput = {
      disposition_distribution_id: this.proceedList.disposition_distribution_id,
      fund_id: null,
      organization_id: null,
      recipient: null,
    };
    switch (this.proceedList.type) {
      case 'Fund':
        proceedInput.fund_id = this.proceedList.id;
        break;
      case 'Organization':
        proceedInput.organization_id = this.proceedList.id;
        break;
      case 'Custom':
        proceedInput.recipient = this.proceedList.name;
    }
    this.dispositionsService.createDispositionDistributionProceed(proceedInput);
  }
  deleteRecipient() {
    const ref: MatDialogRef<ConfirmationModalComponent> = this.dialog.open(
      ConfirmationModalComponent,
      {
        width: '380px',
        height: '200px',
        data: {
          modalTitle: 'Remove Recipient',
          actionMessage: `Are you sure you want to remove ${this.proceedList.name} from this distribution?`,
          modalInformation: [],
        },
        backdropClass: 'confirmDialogComponent',
        hasBackdrop: true,
      }
    );
    ref.afterClosed().subscribe((data) => {
      if (data.clicked === 'Ok') {
        for (let i = 0; i < this.proceedList.proceeds.length; i++) {
          this.dispositionsService.deleteProceed(
            this.proceedList.proceeds[i].id
          );
        }
      }
    });
  }
  proceedChanged() {
    if (!!this.timeout) {
      window.clearTimeout(this.timeout);
    }
    this.timeout = window.setTimeout(() => this.proceedUpdated.emit(true), 500);
  }
  deleteProceed(id: string) {
    const ref: MatDialogRef<ConfirmationModalComponent> = this.dialog.open(
      ConfirmationModalComponent,
      {
        width: '380px',
        height: '200px',
        data: {
          modalTitle: 'Delete Proceed',
          actionMessage: 'Are you sure you want to delete this proceed?',
          modalInformation: [],
        },
        backdropClass: 'confirmDialogComponent',
        hasBackdrop: true,
      }
    );
    ref.afterClosed().subscribe((data) => {
      if (data.clicked === 'Ok') {
        this.dispositionsService.deleteProceed(id);
      }
    });
  }
}
